import TaskManagerEditDto from './TaskManagerEditDto';

export class OutlierDetectorTrainerTaskEditDto extends TaskManagerEditDto {
    constructor() {
        super();

        /** @type {number} */
        this.measurement = null;

        /** @type {number} */
        this.outlierDetector = null;

        /** @type {number} */
        this.timeWindowInDays = null;

        /** @type {Date} */
        this.startDateTime = null;

        /** @type {Date} */
        this.endDateTime = null;
    }

    /**
     * @typedef {Object} _OutlierDetectorTrainerTaskEditDto Props
     * @property {number} measurement
     * @property {number} outlierDetector
     * @property {number} timeWindowInDays
     * @property {number} startDateTime
     * @property {number} endDateTime
     *
     * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _OutlierDetectorTrainerTaskEditDto Props} OutlierDetectorTrainerTaskEditDto Props
     */

    /**
     *
     * @param {OutlierDetectorTrainerTaskEditDto Props} props
     * @returns {OutlierDetectorTrainerTaskEditDto }
     */
    setup(props) {
        super.setup(props);

        this.measurement = props.measurement;
        this.outlierDetector = props.outlierDetector;
        this.timeWindowInDays = props.timeWindowInDays;
        this.startDateTime = props.startDateTime !== null ? new Date(props.startDateTime) : null;
        this.endDateTime = props.endDateTime !== null ? new Date(props.endDateTime) : null;

        return this;
    }
}

export default OutlierDetectorTrainerTaskEditDto;